<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="12">
              <vs-button @click="goBack" color="primary" type="border" icon="keyboard_backspace">Back</vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
              <h3>Edit Company</h3>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="12">
            </vs-col>
          </vs-row>
          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>This Company is a Sole Trader:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <!-- <input type="checkbox" v-model="IsSoleTrader"/> -->
              <vs-switch vs-icon-on="check_box" vs-icon-off="block" v-model="accountDescription.is_sole_trader">
                <span slot="on">YES</span>
                <span slot="off">NO</span>
              </vs-switch>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Source:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" name="source" v-model="accountDescription.source" v-validate="'required'"
                data-vv-as="Source" />
            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('source')">{{ errors.first("source") }}</span>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Company Name:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" name="company_name" v-model="accountDescription.company_name"
                v-validate="'required'" data-vv-as="Company Name" />
            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('company_name')">{{
              errors.first("company_name") }}</span>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Company Registration Number:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" name="company_registration_number"
                v-model="accountDescription.company_registration_number"
                v-validate="{ required: !this.accountDescription.is_sole_trader }"
                data-vv-as="Company Registration Number" />
            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('company_registration_number')">{{
              errors.first("company_registration_number") }}</span>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Company Status:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" name="company_status" v-validate="'required'" v-model="accountDescription.status"
                data-vv-as="Company Status" />
            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('company_status')">{{
              errors.first("company_status") }}</span>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Company Category:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" name="company_category" v-model="accountDescription.company_category"
                data-vv-as="Company Category" />
            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('company_category')">{{
              errors.first("company_category") }}</span>
          </div>
          <vs-divider class="m-5" />

          <!-- Registered Office -->
          <h5 class="mb-5">Registered Office Address</h5>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Address Line 1:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" name="registered_office_address_1"
                v-model="accountDescription.registered_office_address_1" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Address Line 2:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" v-model="accountDescription.registered_office_address_2" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Address Line 3:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" v-model="accountDescription.registered_office_address_3" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>City:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" v-model="accountDescription.registered_office_city" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>County:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" v-model="accountDescription.registered_office_county" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Postcode:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" v-model="accountDescription.registered_office_postcode" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Country:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <AccountAutocomplete ref="accountEditRegisteredOfficeCountryRef"
                :chosen="selected_registered_office_country" class="searchbox" :list="getCountries"
                :searchOn="'registered_office_country'">
              </AccountAutocomplete>

              <!-- <vs-input
                class="w-full"
                v-model="accountDescription.registered_office_country"
              /> -->
            </div>
            <span v-if="registered_office_country_validation" class="text-danger text-sm mt-2 ml-16">{{
              registered_office_country_validation }}</span>
          </div>
          <vs-divider class="m-5" />

          <!-- Head Office -->
          <h5 class="mb-5">Head Office Address</h5>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Head Office Address is the Same As the Registered Office
                Address:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <!-- <input type="checkbox" v-model="headOfficeIsRegisteredOffice"/> -->
              <vs-switch vs-icon-on="check_box" vs-icon-off="block" v-model="headOfficeIsRegisteredOffice">
                <span slot="on">YES</span>
                <span slot="off">NO</span>
              </vs-switch>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Address Line 1:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" v-model="accountDescription.head_office_address_1" name="head_office_address_1" />
            </div>

          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Address Line 2:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" v-model="accountDescription.head_office_address_2" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Address Line 3:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" v-model="accountDescription.head_office_address_3" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>City:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" name="head_office_city" v-model="accountDescription.head_office_city" />
            </div>

          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>County:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" v-model="accountDescription.head_office_county" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Postcode:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" v-model="accountDescription.head_office_postcode" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Country:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <AccountAutocomplete ref="accountEditHeadOfficeCountryRef" :chosen="selected_head_office_country"
                class="searchbox" :list="getCountries" :searchOn="'head_office_country'">
              </AccountAutocomplete>


              <!-- <vs-input
                class="w-full"
                v-model="accountDescription.head_office_country"
              /> -->
            </div>
            <span v-if="head_office_country_validation" class="text-danger text-sm mt-2 ml-16">{{
              head_office_country_validation }}</span>

          </div>
          <vs-divider class="m-5" />
          <div class="vx-row">
            <h6 class="p-5">Website URLs</h6>
          </div>
          <template v-if="accountDescription.web && accountDescription.web.length > 0">

          </template>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <vs-input class="w-full" name="website_url" v-validate="'url:require_protocol'" v-model="accounts.web"
                data-vv-as="website" />
            </div>

            <div class="vx-col sm:w-1/3 w-full">
              <vs-button @click="addWebsite" color="primary" type="filled">Add</vs-button>
              <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('website_url')">{{
                errors.first("website_url") }}</span>
            </div>
          </div>

          <template v-for="website in accountDescription.web">
            <span class="p-5">
              <p>
                {{ website.url }}
                <vs-icon class="ml-10 removeButton" @click="removeSelectedWeb(website)" color="success"
                  icon="clear"></vs-icon>
              </p>
            </span>
          </template>

          <vs-divider class="m-5" />
          <div class="vx-row">
            <h6 class="p-5">Social Media Pages</h6>
          </div>
          <template v-if="
            accountDescription.linkedin &&
            accountDescription.linkedin.length > 0
          ">

          </template>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <vs-input class="w-full" name="linkedin" v-model="accounts.linkedin" />
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-button color="primary" @click="addLinkedin" v-validate="'url:require_protocol'"
                type="filled">Add</vs-button>
              <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('linkedin')">{{
                errors.first("linkedin") }}</span>
            </div>
          </div>

          <template v-for="link in accountDescription.linkedin">
            <span class="p-5">
              <p>
                {{ link.url }}
                <vs-icon class="ml-10 removeButton" @click="removeSelectedLinkedin(link)" color="success"
                  icon="clear"></vs-icon>
              </p>
            </span>
          </template>
          <vs-divider class="m-5" />

          <!-- Site Office -->
          <h5 class="mb-5">Site Office Address</h5>
          <template v-for="(site, index) in accountDescription.satellite_office">
            <div :key="index">
              <vs-divider class="m-5" />
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>Address Line 1:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <vs-input class="w-full" name="satellite_office_address_1" data-vv-as="Address Line 1"
                    v-model="site.address_1" />
                </div>
                <vs-icon class="ml-10 removeButton" @click="removeSelectedSiteAddress(site)" color="success"
                  icon="clear"></vs-icon>

              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>Address Line 2:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <vs-input class="w-full" v-model="site.address_2" />
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>Address Line 3:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <vs-input class="w-full" v-model="site.address_3" />
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>City:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <vs-input class="w-full" v-model="site.city" />
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>County:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <vs-input class="w-full" v-model="site.county" />
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>Postcode:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <vs-input class="w-full" v-model="site.postcode" />
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>Telephone:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full" v-if="site.phone != null">

                  <div  v-if="site.phone.length != 0">
                  <template v-for="(site_ph, ph_index) in site.phone">
                    <div :key="ph_index" v-if="site_ph.satellite_office_id == site.id">
                      <div class="vx-row">
                        <div class="vx-col sm:w-1/2 w-full">
                          <v-select name="phone_code" class="phone_code" label="name_with_code"
                                    :options="all_phone_codes" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="site_ph.phone_code" />
                        </div>
                        <div class="vx-col sm:w-1/2 w-full">
                          <vs-input @input="site_ph.phone_no = site_ph.phone_no.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');" class="w-full" v-model="site_ph.phone_no" />

                        </div>
                        </div>
                    </div>
                  </template>
                </div>

                <div class="vx-col w-full" v-else>
                  
                  <div class="vx-row">
                    <div class="vx-col sm:w-1/2 w-full">
                      <v-select name="phone_code" class="phone_code" label="name_with_code"
                                :options="all_phone_codes" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="site.phone_code" />
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                      <vs-input class="w-full" @input="site.phone_no = site.phone_no.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');" v-model="site.phone_no" />

                    </div>
                </div>
            </div>

                </div>
                
                <div class="vx-col sm:w-1/3 w-full" v-else>
                  
                      <div class="vx-row">
                        <div class="vx-col sm:w-1/2 w-full">
                          <v-select name="phone_code" class="phone_code" label="name_with_code"
                                    :options="all_phone_codes" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="site.phone_code" />
                        </div>
                        <div class="vx-col sm:w-1/2 w-full">
                          <vs-input class="w-full"  @input="site.phone_no = site.phone_no.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');" v-model="site.phone_no" />

                        </div>
                    </div>
                </div>
              </div>
            </div>
          </template>
          <vs-col class="mb-5" vs-offset="4" vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
            <vs-button color="primary" @click="addSiteOffice" type="filled">Add Satellite Office</vs-button>
          </vs-col>

          <vs-divider class="m-5" />
          <!-- Telephone -->
          <div class="vx-row">
            <h6 class="p-5">Telephone Number(s)</h6>

          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <v-select name="phone_code" class="phone_code" label="name_with_code"
                                    :options="all_phone_codes" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="accounts.phone_code" />
              <!-- <vs-input class="w-full" v-model="accounts.phone" /> -->
            </div>
            <div class="vx-col sm:w-1/5 w-full">
              <vs-input @input="accounts.phone = accounts.phone.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');" class="w-full" v-model="accounts.phone" />
            </div>
            <div class="vx-col sm:w-1/5 w-full">
              <v-select label="name" :options="accounts.phoneTypes" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="accounts.phoneType" />
            </div>
            <div class="vx-col sm:w-1/5 w-full">
              <vs-button color="primary" @click="addPhoneNumbers" type="filled">Add</vs-button>
            </div>
          </div>
          <template v-for="phoneAndType in accounts.joinedPhoneAndTypes">
            <p class="m-10">
              {{ phoneAndType }}
              <vs-icon class="ml-10 removeButton" @click="removeNewSelectedPhone(phoneAndType)" color="success"
                icon="clear"></vs-icon>
            </p>
          </template>
          <template v-if="
            accountDescription.phone && accountDescription.phone.length > 0
          ">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <template v-for="phone in accountDescription.phone">
                  <template v-for="p_type in phone.phone_type">
                    <template v-if="phone.id == p_type.phone_id">
                      <p class="m-10">
                        {{ p_type.type }} : {{ phone.phone_code }}{{ phone.phone_no }}
                        <vs-icon class="ml-10 removeButton" @click="removeSelectedPhone(phone)" color="success"
                          icon="clear"></vs-icon>
                      </p>
                      <!-- <template v-if="p_type.type == 'site_switchboard'">
                        <p class="m-10">
                          Site Switchboard - {{ phone.phone_no }}
                          <vs-icon
                            class="ml-10 removeButton"
                            @click="removeSelectedPhone(phone)"
                            color="success"
                            icon="clear"
                          ></vs-icon>
                        </p>
                      </template>

                      <template v-if="p_type.type == 'customer_service'">
                        <p class="m-10">
                          Customer Service - {{ phone.phone_no }}
                          <vs-icon
                            class="ml-10 removeButton"
                            @click="removeSelectedPhone(phone)"
                            color="success"
                            icon="clear"
                          ></vs-icon>
                        </p>
                      </template>

                      <template v-if="p_type.type == 'sales_line'">
                        <p class="m-10">
                          Sales Line - {{ phone.phone_no }}
                          <vs-icon
                            class="ml-10 removeButton"
                            @click="removeSelectedPhone(phone)"
                            color="success"
                            icon="clear"
                          ></vs-icon>
                        </p>
                      </template>

                      <template v-if="p_type.type == 'customer_support_line'">
                        <p class="m-10">
                          Customer Support Line - {{ phone.phone_no }}
                          <vs-icon
                            class="ml-10 removeButton"
                            @click="removeSelectedPhone(phone)"
                            color="success"
                            icon="clear"
                          ></vs-icon>
                        </p>
                      </template>
                      <template v-if="p_type.type == 'others'">
                        <p class="m-10">
                          Others - {{ phone.phone_no }}
                          <vs-icon
                            class="ml-10 removeButton"
                            @click="removeSelectedPhone(phone)"
                            color="success"
                            icon="clear"
                          ></vs-icon>
                        </p>
                      </template> -->
                    </template>
                  </template>
                </template>
              </div>
              <div class="vx-col sm:w-1/3 w-full"></div>
            </div>
          </template>
          <!-- Sic Code -->
          <div class="vx-row">
            <h6 class="p-5">Sic Codes(s)</h6>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/4 w-full">

              <AccountAutocomplete ref="SicCodeRefEdit" class="searchbox" :chosen="selected_sic_code" :list="getSicCodes"
                :searchOn="'sic_codes'"></AccountAutocomplete>
              <!-- <vs-input
                type="number"
                class="w-full"
                v-model="accounts.sic_code"
              /> -->
            </div>

            <div class="vx-col sm:w-1/3 w-full">
              <vs-button color="primary" @click="addSicCodes" type="filled">Add</vs-button>
            </div>
          </div>
          <template v-for="sic in accounts.joinedSicAndDescription">
            <p class="m-10">
              {{ sic.name }}
              <vs-icon class="ml-10 removeButton" @click="removeNewSelectedSicCode(sic)" color="success"
                icon="clear"></vs-icon>
            </p>
          </template>
          <!-- <template v-if="
            accountDescription.sic_code &&
            accountDescription.sic_code.length > 0
          ">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <template v-for="sic in accountDescription.sic_code">
                  <p class="m-10" v-if="sic.sic_code_detail">
                    {{ sic.sic_code_detail.code }} -{{ sic.sic_code_detail.description }}
                    <vs-icon class="ml-10 removeButton" @click="removeSelectedSicCode(sic)" color="success"
                      icon="clear"></vs-icon>
                  </p>
                </template>
              </div>
              <div class="vx-col sm:w-1/3 w-full"></div>
            </div>
          </template> -->
          <vs-divider class="m-5" />
          <h5 class="mb-5">Other Details</h5>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Registration Jurisdiction:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <!-- <AccountAutocomplete ref="EditAccountRegistrationJurisdictionRef" class="searchbox" :list="getCountries"
                :searchOn="'registration_jurisdiction'">
              </AccountAutocomplete> -->

              <AccountAutocomplete ref="EditAccountRegistrationJurisdictionRef"
                :chosen="selected_registration_jurisdiction" class="searchbox" :list="getCountries"
                :searchOn="'registration_jurisdiction'">
              </AccountAutocomplete>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Parent Company:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">

              <AccountAutocomplete ref="EditAccountParentRef" class="searchbox" :list="getParentCompany"
                :searchOn="'parent'">
              </AccountAutocomplete>
            </div>

          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Vertical:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">

              <AccountAutocomplete ref="EditAccountVerticalRef" class="searchbox" :chosen="selected_vertical"
                :list="getVerticals" :searchOn="'vertical'"></AccountAutocomplete>
            </div>

          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Revenue:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/2 w-full">
                  <v-select label="label" :options="currencyCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="accountDescription.currency_code" />
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <vs-input type="number" class="w-full" v-model="accountDescription.revenue" />
                </div>
              </div>
              <span v-if="currency_code_validation" class="text-danger text-sm mt-2 ml-16">{{ currency_code_validation
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>No. of Employees:</span>
            </div>
            <div class="vx-col sm:w-1/6 w-full">
              <vs-input type="number" class="w-full" v-model="accountDescription.no_of_employees" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Notes:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-textarea class="w-full" v-model="accountDescription.notes" />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full"></div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-button class="mr-3 mb-2" @click.prevent="updateForm">Update</vs-button>
            </div>
          </div>
        </vx-card>
      </form>
      <template v-if="accountExists">
        <vs-popup fullscreen :title="companyExistsAccountDescription.company_name" :active.sync="popupActive">
          <div class="flex justify-between flex-wrap">
            <vs-button class="mb-4 mr-6" @click="accept()" type="border">Accept</vs-button>
            <vs-button class="mb-4" type="border" @click="reject()" color="primary">Reject</vs-button>
          </div>
          <vs-list>
            <vs-list-header title="Key Company Details" color="success"></vs-list-header>
            <vs-list-item title="Company Name ">
              {{ companyExistsAccountDescription.company_name }}
            </vs-list-item>
            <vs-list-item title="Company Registration Number">
              {{ companyExistsAccountDescription.company_registration_number }}
            </vs-list-item>
            <vs-list-item title="Switchboard">
              <template v-for="(ph, index) in companyExistsAccountDescription.phone">
                <div :key="index">
                  <template v-for="(ph_type, index2) in ph.phone_type">
                    <div :key="index2" v-if="
                      ph_type.type == 'Switchboard' &&
                      ph_type.phone_id == ph.id
                    ">
                      {{ ph.phone_no }}
                    </div>
                  </template>
                </div>
              </template>
            </vs-list-item>
            <vs-list-item title="Site Switchboard">
              <template v-for="(ph, index) in companyExistsAccountDescription.phone">
                <div :key="index">
                  <template v-for="(ph_type, index2) in ph.phone_type">
                    <div :key="index2" v-if="
                      ph_type.type == 'Site Switchboard' &&
                      ph_type.phone_id == ph.id
                    ">
                      {{ ph.phone_no }}
                    </div>
                  </template>
                </div>
              </template>
            </vs-list-item>
          </vs-list>

          <vs-list>
            <vs-list-header title="Address" color="success"></vs-list-header>
            <vs-list-item title="Head Office Address">
              {{ companyExistsAccountDescription.head_office_address_1 }}
              {{ companyExistsAccountDescription.head_office_address_2 }}
              {{ companyExistsAccountDescription.head_office_address_3 }}
              {{ companyExistsAccountDescription.head_office_city }}
              {{ companyExistsAccountDescription.head_office_postcode }}
              {{ companyExistsAccountDescription.head_office_county }}
              {{ companyExistsAccountDescription.head_office_country }}
            </vs-list-item>
            <vs-list-item title="Registered Office Address">
              {{ companyExistsAccountDescription.registered_office_address_1 }}
              {{ companyExistsAccountDescription.registered_office_address_2 }}
              {{ companyExistsAccountDescription.registered_office_address_3 }}
              {{ companyExistsAccountDescription.registered_office_city }}
              {{ companyExistsAccountDescription.registered_office_postcode }}
              {{ companyExistsAccountDescription.registered_office_county }}
              {{ companyExistsAccountDescription.registered_office_country }}
            </vs-list-item>
            <template v-for="(satellite, index) in companyExistsAccountDescription.satellite_office">
              <vs-list-item :title="'Satellite Office ' + (index + 1)" :key="index">
                <template v-for="(phone, index3) in satellite.phone">
                  <div :key="index3" v-if="phone.satellite_office_id == satellite.id">
                    {{ phone.phone_no }}
                  </div>
                </template>
                {{ satellite.address_1 }}
                {{ satellite.address_2 }}
                {{ satellite.address_3 }}
                {{ satellite.town }}
                {{ satellite.county }}
                {{ satellite.postcode }}

                <template v-for="(country, index2) in satellite.country">
                  <div :key="index2" v-if="country.satellite_office_id == satellite.id">
                    {{ country.name_1 }}
                    {{ country.name_2 }}
                    {{ country.name_3 }}
                  </div>
                </template>
              </vs-list-item>
            </template>
          </vs-list>

          <vs-list>
            <vs-list-header title="Websites" color="success"></vs-list-header>
            <template v-for="(web, index) in companyExistsAccountDescription.web">
              <div :key="index">
                {{ web.url }}
              </div>
            </template>
          </vs-list>
          <vs-list>
            <vs-list-header title="LinkedIn" color="success"></vs-list-header>
            <template v-for="(linkedin, index) in companyExistsAccountDescription.linkedin">
              <div :key="index">
                {{ linkedin.url }}
              </div>
            </template>
          </vs-list>
        </vs-popup>
      </template>
    </div>
  </div>
</template>
<script>
// Store Module
import defineAbilitiesFor from "@/config/abilities";
import moduleAccountsManagement from "@/store/accounts-management/moduleAccountsManagement.js";
import vSelect from "vue-select";
import AccountAutocomplete from "@/components/autocomplete/AccountsAutocomplete.vue";
import _ from "lodash";
export default {
  data() {
    return {
      all_phone_codes: [],
      head_office_country_validation: null,
      companyExistsAccountDescription: {},
      user_id: null,
      user_role: null,
      registered_office_country_validation: null,
      selected_parent_company: null,
      selected_registration_jurisdiction: null,
      selected_vertical: null,
      selected_sic_code: null,
      selected_registered_office_country: null,
      selected_head_office_country: null,
      currency_code_validation: null,
      currencyCodes: [],
      abilities: null,
      showHeadOfficeCountryField: true,
      showEditAutocomplete: false,
      telephone_show_no: 5,
      linkedin_show_no: 5,
      website_show_no: 5,
      accountDescription: {},
      accountExists: false,
      popupActive: false,
      websiteExists: false,
      linkedinExists: false,
      parent_name: null,
      RegistrationJurisdiction: null,
      verticalName: null,
      headOfficeIsRegisteredOffice: false,
      old_head_office_address_1: null,
      old_head_office_address_2: null,
      old_head_office_address_3: null,
      old_head_office_city: null,
      old_head_office_county: null,
      old_head_office_postcode: null,
      old_head_office_country: null,
      old_company_registration_number: null,
      IsSoleTrader: false,
      accounts: {
        web: null,
        phone: null,
        linkedin: null,
        main_counter: 0,
        vertical: null,
        phoneTypes: [],
        phoneType: [],
        phone_code: null,
        joinedPhoneAndTypes: [],
        joinedSicAndDescription: [],
        websites: [],
        linkedins: [],
        phoneWithTypes: [],
        verticals: [],
        vertical: null,
        sic_code: null,
        sic_code_description: null,
        currency_code: null,
        revenue: null,
        no_of_employees: null,
        notes: null
      }
    };
  },
  components: {
    "v-select": vSelect,
    AccountAutocomplete
  },
  created() {
    var self = this;

    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    self.user_id = userInfo["uid"];
    self.user_role = userInfo["userRole"];
    defineAbilitiesFor().then(function (data) {
      self.abilities = data;
    });
    if (!moduleAccountsManagement.isRegistered) {
      this.$store.registerModule(
        "accountsManagement",
        moduleAccountsManagement
      );
      moduleAccountsManagement.isRegistered = true;
    }
    this.getPhoneTypes();
    this.getCurrencyCodes();
  },
  watch: {
    website_show_no(val) {
      if (val) {
        this.accountDescription.webShow = this.accountDescription.web.slice(
          0,
          val
        );
      }
    },
    linkedin_show_no(val) {
      if (val) {
        this.accountDescription.linkedinShow = this.accountDescription.linkedin.slice(
          0,
          val
        );
      }
    },
    telephone_show_no(val) {
      if (val) {
        this.accountDescription.phone = this.accountDescription.phone.slice(
          0,
          val
        );
      }
    },
    "accountDescription.is_sole_trader"(val) {

      this.accountDescription.registered_office_country = this.$refs.accountEditRegisteredOfficeCountryRef.$refs.suggestComponent.value
      this.accountDescription.registered_office_country = this.$refs.accountEditRegisteredOfficeCountryRef.$refs.suggestComponent.input.value

      this.accountDescription.head_office_country = this.$refs.accountEditHeadOfficeCountryRef.$refs.suggestComponent.value
      this.accountDescription.head_office_country = this.$refs.accountEditHeadOfficeCountryRef.$refs.suggestComponent.input.value






      if (val) {
        this.accountDescription.IsSoleTraderFields = {
          company_name: this.accountDescription.company_name,
          head_office_country: this.accountDescription.head_office_country
        };


        if (this.accountDescription.head_office_country == null || this.accountDescription.head_office_country == '') {
          this.head_office_country_validation = 'The Head Office Country field is required'
          this.registered_office_country_validation = null
        } else {
          this.head_office_country_validation = null
        }




      } else {
        this.accountDescription.IsSoleTraderFields = {
          company_registration_number: this.accountDescription
            .company_registration_number,
          registered_office_country: this.accountDescription.registered_office_country
        };



        if (this.accountDescription.registered_office_country == null || this.accountDescription.registered_office_country == '') {
          this.registered_office_country_validation = 'The Registered Office Country field is required'
          this.head_office_country_validation = null
        } else {
          this.registered_office_country_validation = null
        }
      }



    },
    // "accountDescription.head_office_country"(val) {
    //   if (val != this.old_head_office_country) {
    //     this.checkCompanyExists();
    //   }
    // },
    // "accountDescription.company_registration_number"(val) {
    //   if (val != this.old_company_registration_number) {
    //     this.checkCompanyExists();
    //   }
    // },
    headOfficeIsRegisteredOffice(val) {
      if (val) {
        this.accountDescription.head_office_address_1 = this.accountDescription.registered_office_address_1;
        this.accountDescription.head_office_address_2 = this.accountDescription.registered_office_address_2;
        this.accountDescription.head_office_address_3 = this.accountDescription.registered_office_address_3;
        this.accountDescription.head_office_city = this.accountDescription.registered_office_city;
        this.accountDescription.head_office_county = this.accountDescription.registered_office_county;
        this.accountDescription.head_office_postcode = this.accountDescription.registered_office_postcode;

        this.$refs.accountEditHeadOfficeCountryRef.$refs.suggestComponent.value = this.$refs.accountEditRegisteredOfficeCountryRef.$refs.suggestComponent.value
        this.$refs.accountEditHeadOfficeCountryRef.$refs.suggestComponent.input.value = this.$refs.accountEditRegisteredOfficeCountryRef.$refs.suggestComponent.input.value


      } else {

        if (this.old_head_office_country == null) {
          this.$refs.accountEditHeadOfficeCountryRef.$refs.suggestComponent.input.value = null
          this.$refs.accountEditHeadOfficeCountryRef.$refs.suggestComponent.value = null

        }
        else {
          this.$refs.accountEditHeadOfficeCountryRef.$refs.suggestComponent.input.value = this.old_head_office_country
          this.$refs.accountEditHeadOfficeCountryRef.$refs.suggestComponent.value = this.old_head_office_country
        }

        this.accountDescription.head_office_address_1 = this.old_head_office_address_1;
        this.accountDescription.head_office_address_2 = this.old_head_office_address_2;
        this.accountDescription.head_office_address_3 = this.old_head_office_address_3;
        this.accountDescription.head_office_city = this.old_head_office_city;
        this.accountDescription.head_office_county = this.old_head_office_county;
        this.accountDescription.head_office_postcode = this.old_head_office_postcode;

        if (this.$refs.accountEditHeadOfficeCountryRef.$refs.suggestComponent.value != null || this.$refs.accountEditHeadOfficeCountryRef.$refs.suggestComponent.value != '') {
          this.head_office_country_validation = null

        }

        if (this.$refs.accountEditRegisteredOfficeCountryRef.$refs.suggestComponent.value != null || this.$refs.accountEditRegisteredOfficeCountryRef.$refs.suggestComponent.value != '') {
          this.registered_office_country_validation = null

        }


      }
    },
    "accounts.websites"(val) {
      if (val) {
        var lastItem = val[val.length - 1];
        if (this.validDomain(lastItem)) {
          this.$store
            .dispatch("accountsManagement/checkWebsiteExists", lastItem)
            .then(res => {
              if (res.data.status == "fail") {
                this.websiteExists = true;
                this.$vs.dialog({
                  color: "primary",
                  title: `Confirm`,
                  text: "This website already exists.",
                  accept: (this.websiteExists = false)
                });
                var index = this.accounts.websites.indexOf(lastItem);
                this.accounts.websites.splice(index, 1);
              } else {
                return;
              }
            })
            .catch(err => {
              if (err.response.status === 401) {
                this.$router.replace("/login");
              }
            });
        } else {
          var index = this.accounts.websites.indexOf(lastItem);
          this.accounts.websites.splice(index, 1);
          return false;
        }
      }
    },
    "accounts.linkedins"(val) {
      if (val) {
        var lastItem = val[val.length - 1];
        if (this.validDomain(lastItem)) {
          this.$store
            .dispatch("accountsManagement/checkLinkedinExists", lastItem)
            .then(res => {
              if (res.data.status == "fail") {
                this.linkedinExists = true;
                this.$vs.dialog({
                  color: "primary",
                  title: `Confirm`,
                  text: "This linkedin already exists.",
                  accept: (this.linkedinExists = false)
                });
                var index = this.accounts.linkedins.indexOf(lastItem);
                this.accounts.linkedins.splice(index, 1);
              } else {
                return;
              }
            })
            .catch(err => {
              if (err.response.status === 401) {
                this.$router.replace("/login");
              }
            });
        } else {
          var index = this.accounts.linkedins.indexOf(lastItem);
          this.accounts.linkedins.splice(index, 1);
          return false;
        }
      }
    }
  },
  mounted() {
    this.getAllPhoneCodes()
    let accountId = this.$route.params.accountId;
    this.$store
      .dispatch("accountsManagement/fetchAccount", accountId)
      .then(res => {
        this.accountDescription = res.data;


          console.log("DESCCCCCCCCC" , this.accountDescription);

        this.accountDescription.IsSoleTraderFields = {};
        this.old_head_office_address_1 = this.accountDescription.head_office_address_1;
        this.old_head_office_address_2 = this.accountDescription.head_office_address_2;
        this.old_head_office_address_3 = this.accountDescription.head_office_address_3;
        this.old_head_office_city = this.accountDescription.head_office_city;
        this.old_head_office_county = this.accountDescription.head_office_county;
        this.old_head_office_postcode = this.accountDescription.head_office_postcode;


        this.$refs.accountEditHeadOfficeCountryRef.$refs.suggestComponent.input.value = this.accountDescription.head_office_country;
        this.$refs.accountEditHeadOfficeCountryRef.$refs.suggestComponent.value = this.accountDescription.head_office_country;
        this.old_head_office_country = this.accountDescription.head_office_country;


        this.$refs.accountEditRegisteredOfficeCountryRef.$refs.suggestComponent.input.value = this.accountDescription.registered_office_country;
        this.$refs.accountEditRegisteredOfficeCountryRef.$refs.suggestComponent.value = this.accountDescription.registered_office_country;


        this.old_company_registration_number = this.accountDescription.company_registration_number;

        this.accountDescription.phone = this.accountDescription.phone.slice(
          0,
          this.telephone_show_no
        );
        if (this.accountDescription.parent) {
          this.showParentName(this.accountDescription.parent);
        }



        if (this.accountDescription.registration_jurisdiction) {
          this.showRegistrationJurisdiction(
            this.accountDescription.registration_jurisdiction
          );
        }
        if (this.accountDescription.vertical) {
          this.showVertical(this.accountDescription.vertical);
        }
        var self = this;

        this.$store
          .dispatch("accountsManagement/getCurrencyCodes")
          .then(response => {
            let result = response.data;

            if (self.accountDescription.currency_code) {
              result.forEach(function (ele) {
                if (ele.id == self.accountDescription.currency_code) {
                  self.accountDescription.currency_code = ele.symbol + ' ' + ele.name + ' ' + ele.code
                }
              });
            }
          })
          .catch(err => {
            if (err.response.status === 404) {
              console.log("Error");
              return;
            }
            console.error(err);
          });

        this.accountDescription.satellite_office = this.accountDescription.satellite_office.map(
          ele => {
            let counter = 0;
            ele.counter = ++this.accounts.main_counter;
            return ele;
          }
        );


        // this.accounts.joinedSicAndDescription = this.accountDescription.sic_code
        this.accountDescription.sic_code.forEach(function (e) {
          let mapped = {}
          mapped.id = e.sic_code_detail.id,
            mapped.name = e.sic_code_detail.code + ' - ' + e.sic_code_detail.description
          self.accounts.joinedSicAndDescription.push(mapped)
        })
      })
      .catch(err => {
        if (err.response.status === 404) {
          this.accountDescription = true;
          return;
        }
        console.error(err);
      });
  },
  methods: {
    getAllPhoneCodes() {
      let self = this
      this.$store
        .dispatch("accountsManagement/getAllPhoneCodes")
        .then(response => {
          self.all_phone_codes = response.data
          self.all_phone_codes.forEach(function (ele) {
            if (ele.phone_code) {
              ele.name_with_code = ele.phone_code + ' - ' + ele.name_1
            }
            return ele
          })
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getSicCodes(inputValue) {
      return this.$store
        .dispatch("accountsManagement/getSicCodes", inputValue)
        .then(response => {
          let data = moduleAccountsManagement.state.sic_codes;
          // console.log(data);
          let mappedArray = [];
          for (const property in data) {
            mappedArray.push({
              id: data[property].id,
              name: data[property].code + ' - ' + data[property].description
            });
          }
          return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    editHeadOfficeCountry() {
      this.showHeadOfficeCountryField = false;
      this.showEditAutocomplete = true;
      // console.log(this.$refs.EditAutoComplete.$refs.suggestComponent);
      this.$refs.EditAutoComplete.$refs.suggestComponent.isInFocus = true;
      this.$refs.EditAutoComplete.$refs.suggestComponent.isClicking = true;
      this.$refs.EditAutoComplete.$refs.suggestComponent.input.value = this.accountDescription.head_office_country;
      this.$refs.EditAutoComplete.$refs.suggestComponent.value = this.accountDescription.head_office_country;
    },
    goBack: function () {
      this.$router.push({ path: `/accounts` });
    },
    showGroupCompanies() {
      const parentId = this.accountDescription.parent;
      this.$store
        .dispatch("accountsManagement/getGroupCompanies", parentId)
        .then(res => {
          this.groupCompanies = res.data;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.groupCompanies = true;
            return;
          }
          console.error(err);
        });
    },
    getCurrencyCodes(inputValue) {
      return this.$store
        .dispatch("accountsManagement/getCurrencyCodes")
        .then(response => {
          let response_data = response.data
          let mappedArray = [];
          for (const property in response_data) {
            mappedArray.push({
              id: response_data[property].id,
              label: response_data[property].symbol + ' ' + response_data[property].name + ' ' + response_data[property].code
            });
          }
          this.currencyCodes = mappedArray
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    showParentName(parentId) {
      this.$store
        .dispatch("accountsManagement/getParent", parentId)
        .then(res => {
          this.$refs.EditAccountParentRef.$refs.suggestComponent.input.value = res.data.company_name;
          this.$refs.EditAccountParentRef.$refs.suggestComponent.value = res.data.company_name;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.parent_name = true;
            return;
          }
          console.error(err);
        });
    },
    showRegistrationJurisdiction(countryId) {
      this.$store
        .dispatch("accountsManagement/getCountry", countryId)
        .then(res => {
          this.$refs.EditAccountRegistrationJurisdictionRef.$refs.suggestComponent.input.value = res.data.name_1
          this.$refs.EditAccountRegistrationJurisdictionRef.$refs.suggestComponent.value = res.data.name_1
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.accountDescription.parent = true;
            return;
          }
          console.error(err);
        });
    },
    showVertical(verticalId) {
      this.$store
        .dispatch("accountsManagement/getVertical", verticalId)
        .then(res => {
          // this.verticalName = res.data.vertical;
          this.$refs.EditAccountVerticalRef.$refs.suggestComponent.input.value = res.data.vertical;
          this.$refs.EditAccountVerticalRef.$refs.suggestComponent.value = res.data.vertical;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    removeSelectedSiteAddress(site) {
      this.accountDescription.satellite_office = this.accountDescription.satellite_office.filter(
        item => {
          return item.counter != site.counter;
        }
      );
    },
    addSiteOffice() {
      this.accountDescription.satellite_office.push({
        counter: ++this.accounts.main_counter,
        address_1: null,
        address_2: null,
        address_3: null,
        city: null,
        county: null,
        postcode: null,
        country: null,
        phone: null,
        phone_code: null
      });
      // console.log(this.accounts.main_counter);
      // console.log(this.accounts.satellite);
    },
    removeSelectedWeb(url) {
      this.accountDescription.web = this.accountDescription.web.filter(item => {
        return item != url;
      });
    },
    removeSelectedLinkedin(url) {
      this.accountDescription.linkedin = this.accountDescription.linkedin.filter(
        item => {
          return item != url;
        }
      );
    },
    removeSelectedPhone(phone) {
      this.accountDescription.phone = this.accountDescription.phone.filter(
        item => {
          return item != phone;
        }
      );
      this.accountDescription.phone = this.accountDescription.phone;
    },
    removeSelectedSicCode(sic_code) {
      this.accountDescription.sic_code = this.accountDescription.sic_code.filter(
        item => {
          return item != sic_code;
        }
      );
      this.accountDescription.phone = this.accountDescription.phone;
    },
    removeNewSelectedSicCode(selected) {
      this.accounts.joinedSicAndDescription = this.accounts.joinedSicAndDescription.filter(
        item => {
          return item != selected;
        }
      );
    },
    removeNewSelectedPhone(selected) {
      this.accounts.joinedPhoneAndTypes = this.accounts.joinedPhoneAndTypes.filter(
        item => {
          return item != selected;
        }
      );
    },
    validDomain(userInput) {
      if (userInput) {
        var res = userInput.match(
          /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
        );
        if (res == null) {
          return false;
        }
      }
      return true;
    },
    addPhoneNumbers() {
      if (
        this.accounts.phone_code &&
        this.accounts.phone &&
        this.accounts.phoneType &&
        !this.accounts.joinedPhoneAndTypes.includes(
          this.accounts.phoneType.name + " : " + this.accounts.phone_code.phone_code + " - " + this.accounts.phone
        )
      )
        this.accounts.joinedPhoneAndTypes.push(
          this.accounts.phoneType.name + " : " + this.accounts.phone_code.phone_code + " - " + this.accounts.phone
        );
      let mappedPhoneTypes = {};
      mappedPhoneTypes.phone_no = this.accounts.phone;
      mappedPhoneTypes.phone_type = this.accounts.phoneType.slug;
      mappedPhoneTypes.phone_code = this.accounts.phone_code.phone_code;      

      this.accounts.phoneWithTypes.push(mappedPhoneTypes);
      this.accounts.phone = null;
      this.accounts.phone_code = null;
      this.accounts.phoneType = null;
    },
    addSicCodes() {
      // if (
      //   this.accounts.sic_code &&
      //   this.accounts.sic_code_description &&
      //   !this.accounts.joinedSicAndDescription.includes(
      //     this.accounts.sic_code + " - " + this.accounts.sic_code_description
      //   )
      // )
      //   this.accounts.joinedSicAndDescription.push(
      //     this.accounts.sic_code + " - " + this.accounts.sic_code_description
      //   );
      // let mappedSic = {};
      // mappedSic.code = this.accounts.sic_code;
      // mappedSic.description = this.accounts.sic_code_description;


      this.accounts.joinedSicAndDescription.push(
        moduleAccountsManagement.sic_codes_selected
      );








      // console.log(moduleAccountsManagement.sic_codes_selected)
      // this.accounts.sicWithDescription.push(moduleAccountsManagement.sic_codes_selected);

      this.$refs.SicCodeRefEdit.$refs.suggestComponent.selected = null
      this.$refs.SicCodeRefEdit.$refs.suggestComponent.input.value = null
      this.$refs.SicCodeRefEdit.$refs.suggestComponent.value = null

      this.selected_sic_code = null
    },
    addWebsite() {
      if (
        this.accounts.web &&
        !this.accountDescription.web.includes(this.accounts.web)
      )
        this.accountDescription.web.push({ url: this.accounts.web });
      this.accounts.web = null;
    },
    addLinkedin() {
      if (
        this.accounts.linkedin &&
        !this.accountDescription.linkedin.includes(this.accounts.linkedin)
      )
        this.accountDescription.linkedin.push({ url: this.accounts.linkedin });
      this.accounts.linkedin = null;
    },
    updateForm() {





      this.accountDescription.registered_office_country = this.$refs.accountEditRegisteredOfficeCountryRef.$refs.suggestComponent.value
      this.accountDescription.registered_office_country = this.$refs.accountEditRegisteredOfficeCountryRef.$refs.suggestComponent.input.value

      this.accountDescription.head_office_country = this.$refs.accountEditHeadOfficeCountryRef.$refs.suggestComponent.value
      this.accountDescription.head_office_country = this.$refs.accountEditHeadOfficeCountryRef.$refs.suggestComponent.input.value








      this.$validator.validateAll().then(result => {
        if (result) {






          if (this.accountDescription.is_sole_trader) {
            this.accountDescription.IsSoleTraderFields = {
              company_name: this.accountDescription.company_name,
              head_office_country: this.accountDescription.head_office_country
            };

            if (this.accountDescription.head_office_country == null || this.accountDescription.head_office_country == '') {
              this.head_office_country_validation = 'The Head Office Country field is required'
              this.registered_office_country_validation = null
              return false
            } else {
              this.head_office_country_validation = null
            }




          } else {
            this.accountDescription.IsSoleTraderFields = {
              company_registration_number: this.accountDescription
                .company_registration_number,
              registered_office_country: this.accountDescription.registered_office_country
            };


            if (this.accountDescription.registered_office_country == null || this.accountDescription.registered_office_country == '') {
              this.registered_office_country_validation = 'The Registered Office Country field is required'
              this.head_office_country_validation = null
              return false
            } else {
              this.registered_office_country_validation = null
            }



          }
          if (moduleAccountsManagement.autocomplete_selected) {
            this.accountDescription.parent =
              moduleAccountsManagement.autocomplete_selected.id;
          }
          if (moduleAccountsManagement.vertical_selected) {
            this.accountDescription.vertical =
              moduleAccountsManagement.vertical_selected.id;
          }
          if (moduleAccountsManagement.countries_selected) {
            this.accountDescription.registration_jurisdiction =
              moduleAccountsManagement.countries_selected.id;
          }

          this.accountDescription.id = this.$route.params.accountId;

          this.accountDescription.phoneWithTypes = [];
          this.accountDescription.phone.map(phone_ele => {
            phone_ele.phone_type.map(phone_type_ele => {
              if (phone_type_ele.phone_id == phone_ele.id) {
                let mappedPhoneTypes = {};
                mappedPhoneTypes.phone_code = phone_ele.phone_code;
                mappedPhoneTypes.phone_no = phone_ele.phone_no;
                mappedPhoneTypes.phone_type = phone_type_ele.type;
                this.accountDescription.phoneWithTypes.push(mappedPhoneTypes);
              }
            });
          });
          this.accountDescription.phoneWithTypes = _.unionBy(
            this.accountDescription.phoneWithTypes,
            this.accounts.phoneWithTypes,
            "phone_no"
          );

          this.accountDescription.joinedSicAndDescription = this.accounts.joinedSicAndDescription

          if (
            this.accountDescription.revenue != null &&
            this.accountDescription.currency_code == null
          ) {
            this.currency_code_validation =
              "The currency code field is required";
            return false;
          }

          this.accountDescription.user_id = this.user_id
          this.updateAccount();
          // if form have no errors
        } else {
          // form have errors
        }
      });
    },
    updateAccount() {
      this.$vs.loading()
      this.$store
        .dispatch("accountsManagement/updateAccount", this.accountDescription)
        .then(res => {
          if (res.data.status == "fail") {
            this.checkCompanyExists()
          } else {
            this.$vs.notify({
              color: "success",
              title: "Account",
              text: res.data.message
            });
            this.$router.push({ path: "/accounts" });
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        }).finally(() => {
          this.$vs.loading.close()
        })
    },
    checkCompanyExists() {
      if (this.accountDescription.is_sole_trader) {
        this.accountDescription.IsSoleTraderFields = {
          company_name: this.accountDescription.company_name,
          head_office_country: this.accountDescription.head_office_country
        };
      } else {
        this.accountDescription.IsSoleTraderFields = {
          company_registration_number: this.accountDescription
            .company_registration_number,
          registered_office_country: this.accountDescription.registered_office_country
        };
      }
      this.accountDescription.IsSoleTraderFields.is_sole_trader = this.accountDescription.is_sole_trader
      this.$store
        .dispatch(
          "accountsManagement/checkCompanyExists",
          this.accountDescription.IsSoleTraderFields
        )
        .then(res => {
          if (res.data.status == "fail") {
            this.companyExistsAccountDescription = res.data.data;
            this.accountExists = true;
            this.popupActive = true;
          } else {
            return;
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getPhoneTypes() {
      this.$store
        .dispatch("accountsManagement/getPhoneTypes")
        .then(res => {
          this.accounts.phoneTypes = res.data;
          this.accounts.phoneTypes = this.accounts.phoneTypes.filter(
            item => item.name != "Site Switchboard"
          );
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getVerticals(inputValue) {
      return this.$store
        .dispatch("accountsManagement/getVerticals", inputValue)
        .then(response => {
          let data = moduleAccountsManagement.state.verticals;
          let mappedArray = [];
          for (const property in data) {
            mappedArray.push({
              id: data[property].id,
              name: data[property].vertical
            });
          }
          return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getCountries(inputValue) {
      return this.$store
        .dispatch("accountsManagement/getCountries", inputValue)
        .then(response => {
          let data = moduleAccountsManagement.state.countries;
          // console.log(data);
          let mappedArray = [];
          for (const property in data) {
            mappedArray.push({
              id: data[property].id,
              name: data[property].name_1
            });
          }
          return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    accept() {
      this.popupActive = false
    },
    reject() {
      // this.popupActive = false;
      // this.$router.push({ path: "/dashboard" });
      this.$router.go(0);
    },
    getParentCompany(inputValue) {
      return this.$store
        .dispatch("accountsManagement/searchAutocomplete", inputValue)
        .then(response => {
          let data = JSON.parse(JSON.parse(JSON.stringify(response.data)));
          let mappedArray = [];
          for (const property in data) {
            mappedArray.push({
              id: data[property].uuid,
              name: data[property].company_name
            });
          }
          return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    }
  }
};
</script>
<style scoped>
.removeButton {
  cursor: pointer;
}

.inputx {
  width: 50px;
}
</style>
